module.exports = __webpack_public_path__ + "img/delete-icon.e8c8ccbe.svg";